import React, { useEffect, useState } from "react"
import { IReplenishmentDto } from "../../../../types/replenishment/IReplenishmentDto"
import * as TrinityAPI from "../../../../requests/TrinityAPI"
import { ICompanyBank, IFullCompanyDto } from "../../../../types/company/IFullCompanyDto"
import { IModalMessage } from "../../../../types/error/IModalMessage"
import { ModalPopUp } from "../../../common/element/ModalPopUp"
import { useStore } from "@/stores/RootStoreContext"

export const CompanyTab: React.FC<{
  replenishment: IReplenishmentDto
  setReplenishment: (r: IReplenishmentDto) => void
}> = ({ replenishment, setReplenishment }) => {
  const { userStore } = useStore()

  const [companies, setCompanies] = useState<IFullCompanyDto[]>([])
  const [company, setCompany] = useState<IFullCompanyDto>()
  const [bank, setBank] = useState<ICompanyBank>()
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [sending, setSending] = useState(false)

  const isAdmin = userStore.isAdmin

  useEffect(() => {
    TrinityAPI.getCompanyList(response => {
      if (response.status === 200) {
        setCompanies(response.data)
      } else {
        setModalMessage({
          title: "Ошибка!",
          text: `Ошибка загрузки списка компаний: ${response.data}`
        })
      }
    })
  }, [])

  useEffect(() => {
    if (replenishment.companyId) {
      setCompany(companies.find(company => company.id === replenishment.companyId))
    }
  }, [companies])

  useEffect(() => {
    if (replenishment.bankId) {
      setBank(company?.banks?.find(bank => bank.id === replenishment.bankId))
    }
  }, [company])

  const pickCompany = (id: string) => {
    setReplenishment({ ...replenishment, companyId: id, bankId: undefined })
    setCompany(companies.find(company => String(company.id) === id))
  }

  const pickBank = (id: string) => {
    setReplenishment({ ...replenishment, bankId: id })
    setBank(company?.banks?.find(bank => String(bank.id) === id))
  }

  const submit = (accepted: boolean) => {
    if (sending) return
    if (!replenishment.companyId) {
      setModalMessage({
        title: "Ошибка!",
        text: "Выберите компанию, через которую будет производится оплата инвойса клиента"
      })
      return
    }
    setSending(true)

    const payload: IReplenishmentDto = {
      ...replenishment,
      onTopAmount: replenishment.onTopAmount ? String(Number(replenishment.onTopAmount) * 100) : ""
    }
    TrinityAPI.checkDocs(payload, accepted, response => {
      if (response.status === 200) {
        window.location.href = "/replenishment"
      } else {
        setModalMessage({ title: "Ошибка!", text: response.message })
        setSending(false)
      }
    })
  }

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <div
        className="container"
        style={replenishment.status !== "DOC" && !isAdmin ? { pointerEvents: "none", opacity: 0.7 } : {}}
      >
        <div className="container-pop-up">
          {/*<ul className="form-block-popup width-full">*/}
          <li className="form-block-popup width-full">
            <h4 className="heading-chapter">Компания</h4>
            <fieldset>
              <legend>Выберите компанию, через которую будет произведена оплата</legend>
              <select value={replenishment.companyId} onChange={e => pickCompany(e.target.value)} className="text-form">
                <option value="">Выберите компанию</option>
                {companies.map((c, index) => (
                  <option value={c.id} key={index}>
                    {c.name}
                  </option>
                ))}
              </select>
            </fieldset>
            <fieldset style={!company ? { pointerEvents: "none", opacity: "0.5" } : {}}>
              <legend>Выберите счет</legend>
              <select value={replenishment.bankId} onChange={e => pickBank(e.target.value)} className="text-form">
                <option value="">Выберите счет</option>
                {(company?.banks?.length || 0) > 0
                  ? company?.banks?.map((c, index) => (
                      <option value={String(c.id)} key={index}>
                        #{c.id} {c.swift} - {c.accountNumber} - {c.currency}
                      </option>
                    ))
                  : null}
              </select>
            </fieldset>
          </li>
          {/*</ul>*/}
          {bank && company ? (
            <div className="container-pop-up">
              <div className="form-left width-full">
                <div className="form-block-popup">
                  <h4 className="heading-chapter">О компании</h4>
                  <div className="popup-gruop-text">
                    <h3 className="popup-heading">{company.name}</h3>
                    <p className="popup-text">
                      <span className="popup-subline">Юрисдикция:&nbsp;</span>
                      {company.country?.name}
                    </p>
                  </div>
                </div>

                <div className="form-block-popup">
                  <h4 className="heading-chapter">Страны исключения</h4>
                  <ul className="tag-list">
                    {company.countryExclusions?.map((ce, index) => (
                      <li className="tag-item" key={index}>
                        {ce.name}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div>
                {(replenishment.status === "DOC" || isAdmin) && (
                  <div className="flex-row-10">
                    <button className="btn" onClick={() => submit(true)}>
                      {sending ? "Подождите..." : "Принять документы"}
                    </button>
                    {/*<button className="btn grey-btn"*/}
                    {/*        onClick={() => window.location.href = "/replenishment"}>В каталог пополнений*/}
                    {/*</button>*/}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  )
}
